export default {
  isLoading: false,
  roles: [],
};
